/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../../js-controller';
import { f } from 'msw/lib/glossary-58eca5a8';

declare let embedded_svc: any;
declare let embeddedservice_bootstrap: any;
declare const window: any;

export default (app: App) => {

    const controller = new JsController(app, 'salesforce-chat-MIAW');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

export function mountComponent( controller: JsController ) {
        
    const salesforceElement= document.querySelector<HTMLElement>("#salesforce-chat-miaw");
    const chatInitiator = document.querySelector<HTMLElement>("#chat-initiator");
    const chatDialog = document.querySelector<HTMLElement>("#custom-chat-dialog");
    const loadingIcon = document.querySelector<HTMLElement>("#loading-icon");
    const closeChatIcon = document.querySelector<HTMLElement>("#chat-close");

    if(salesforceElement){        
    const chatId= salesforceElement.dataset.chatId;
    const deploymentName= salesforceElement.dataset.deploymentName;
    const deploymentURL= salesforceElement.dataset.deploymentUrl;
    const scrtURL= salesforceElement.dataset.scrtUrl;
    const scriptSource= salesforceElement.dataset.scriptSource??"";
    const projectId= salesforceElement.dataset.projectId;
    
    const sourceURL = window.location.href ;
    let formattedUrl = sourceURL.split("?")[0];
    formattedUrl = formattedUrl.substring(0, 99);
    
    function initEmbeddedMessaging() {
        try {  
    window.addEventListener("onEmbeddedMessagingReady", () => {
    console.log("Received the onEmbeddedMessagingReady event…");
    
    // Send data to Salesforce
    embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({"BrowserURL" : formattedUrl});
    embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({"ProjectId" : projectId});
    
    });
    chatInitiator?.addEventListener("click", () => {
        addToCookie("chatInitiatorClicked", "true", 1);
        loadingIcon?.classList.remove("hidden");
        embeddedservice_bootstrap.utilAPI.launchChat().then(function(){
            console.log("Chat Launched");
            chatDialog?.classList.add("hidden");
        })
    });

    closeChatIcon?.addEventListener("click", () => {
        chatDialog?.classList.add("hidden");
        addToCookie("chatInitiatorClicked", "true", 1);
    });

    
    window.addEventListener("onEmbeddedMessagingWindowMaximized", () => {
        chatDialog?.classList.add("hidden");
    });
    embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'

    embeddedservice_bootstrap.init(
        chatId,
        deploymentName,
        deploymentURL,
        {
            scrt2URL: scrtURL
        }
    );   
    
    } catch (err) {
        console.error('Error loading Embedded Messaging: ', err);
    }
    };

    function addToCookie(name:string, value:string, days:number) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }
    
    function getCookie(name:string) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)===' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function loadChatScript() {
         if(!document.querySelector(`script[src="${scriptSource}"]`)) {
         const s = document.createElement('script');
         s.type = 'text/javascript';
         s.setAttribute('src', scriptSource);
         s.onload = function(){ 
             initEmbeddedMessaging();
             if(getCookie("chatInitiatorClicked") === "true") {
                 chatDialog?.classList.add("hidden");
             }
             else {  
                 setTimeout(() => {
                 chatDialog?.classList.remove("hidden");
                 }, 3000);
             }
        }  
        document.body.append(s);
        }   
         else {
             initEmbeddedMessaging();    
         }
    }  
    if(document.readyState === 'complete') {
         loadChatScript();
    }
    else {
         window.addEventListener('load', loadChatScript);
    }
    }
} 
